import {
  Grid,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  IconButton,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const OPS = [" == ", " != ", " > ", " < ", " >= ", " <= "];

export default function FilterRow({ data, fields, onChange, onRemove }) {
  return (
    <Box mt={3}>
      <Grid container spacing={3}>
        <Grid item xs={5}>
          <FormControl sx={{ minWidth: 120, width: "100%" }}>
            <InputLabel>Select Field</InputLabel>
            <Select
              label="Select Field"
              fullWidth
              value={data.field}
              onChange={(e) =>
                onChange({
                  ...data,
                  field: e.target.value,
                })
              }
              sx={{ padding: "12px", paddingLeft: "3px" }}
            >
              {fields.map((f) => (
                <MenuItem key={f.key} value={f.key}>
                  {f.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={3}>
          <FormControl sx={{ minWidth: 120, width: "100%" }}>
            <InputLabel>Select Operator</InputLabel>
            <Select
              label="Select Operator"
              fullWidth
              value={data.op}
              onChange={(e) =>
                onChange({
                  ...data,
                  op: e.target.value,
                })
              }
              sx={{ padding: "12px", paddingLeft: "3px" }}
            >
              {OPS.map((o) => (
                <MenuItem key={o} value={o}>
                  {o}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={3}>
          <TextField
            fullWidth
            value={data.value}
            onChange={(e) =>
              onChange({
                ...data,
                value: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={1}>
          <IconButton color="error" onClick={onRemove}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
}
